import { FC } from "react";

const RefundPolicyContainer: FC = () => {
  return (
    <>
      <h1>Course Cancellation Policy</h1>
      <p>
        <b>If a Customer Cancels a Regularly Scheduled Course at a Genie Training Center</b> - Genie must be
        notified of the cancellation at least 14 days prior to the scheduled course. Cancellations that are
        made less than 14 days before the class are non-refundable. However the registration fee may be
        applied to another scheduled class depending upon availability.
      </p>
      <p>
        <b>If a Customer Cancels a Scheduled Course at the Customer Location</b> - Genie must be notified of
        the cancellation at least 21 days prior to the scheduled course. Cancellations that are made less than
        21 days before the class will result in a charge for all registration fees and all
        expenses/cancellation fees incurred by the trainer.
      </p>
      <p>
        <b>If Genie Cancels a Regularly Scheduled Course at a Genie Training Center</b> - Every reasonable
        attempt will be made to conduct scheduled courses. In the rare event that a course must be canceled,
        customers will be notified 30 days prior to the course start date whenever possible. Genie cannot be
        held responsible for any incurred expenses due to class cancellations. Please schedule your travel
        plans accordingly.
      </p>
      <p>
        <b>If Genie Cancels a Scheduled Course at the Customer Location </b> - Every reasonable attempt will
        be made to conduct scheduled courses. In the rare event that a course must be canceled, customers will
        be notified 30 days prior to the course start date whenever possible. Any pre-payments made for the
        course will be refunded in their entirety.
      </p>
      <style jsx>{`
        h1,
        p {
          font-size: 14px;
          line-height: 1.42857143;
          color: #333;
        }

        h1 {
          font-weight: 700;
        }
      `}</style>
    </>
  );
};

export default RefundPolicyContainer;
